import Demo from "../../../../../src/demo.jsx";
import React from 'react';
export default {
  Demo,
  React
};